module.exports = __webpack_public_path__ + "media/hyper/images/products/product-4-079136a1fbcf48530d1772b9e3c9bd86.jpg";